import { render, staticRenderFns } from "./ReviewOrdersCards.vue?vue&type=template&id=548ed64a"
import script from "./ReviewOrdersCards.vue?vue&type=script&lang=js"
export * from "./ReviewOrdersCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports